// Which cubes the selected themes expand to. A pure function over the
// aggregations config (fetched from the Pod via /api/config/aggregations), used
// by the partner flow to show what is about to be published before anything is
// written.
//
// Themes dissolved into a flat aggregates[] carrying a per-aggregate `theme`
// tag; `period` is the global dimension appended to every aggregate. This
// mirrors the server (web/server/publish.js `selectedSlices`) exactly — the
// backend recomputes the same list from the same Pod config when it actually
// publishes, so this copy is for the preview, never the authority on what ships.

export function selectedSlices(aggregations, themeFlags) {
  const period = aggregations.period;
  return aggregations.aggregates
    .filter((a) => themeFlags[a.theme])
    .map((a) => ({
      dataSet: a.id,
      theme: a.theme,
      dimensions: period ? [...a.dimensions, period] : a.dimensions,
      measure: a.measure ?? aggregations.measure,
      reducer: a.reducer ?? 'count',
    }));
}

// The distinct themes in the config, each with the aggregates it groups. Themes
// are no longer a first-class config object, so the partner "grant by theme"
// step derives them here: suppression is global; the sharing policy is uniform
// within a theme today (diversity mutual, operations unilateral), so the group
// carries the first member's `sharing`.
export function themeGroups(aggregations) {
  const period = aggregations.period;
  const byTheme = new Map();
  for (const a of aggregations.aggregates) {
    if (!byTheme.has(a.theme)) {
      byTheme.set(a.theme, {
        name: a.theme,
        suppressBelow: aggregations.suppressBelow,
        sharing: a.sharing ?? { mode: 'mutual' },
        slices: [],
      });
    }
    byTheme.get(a.theme).slices.push({
      dataSet: a.id,
      dimensions: period ? [...a.dimensions, period] : a.dimensions,
      measure: a.measure ?? aggregations.measure,
      reducer: a.reducer ?? 'count',
      suppressMeasureBelow: a.suppressMeasureBelow ?? null,
    });
  }
  return [...byTheme.values()];
}
